import { useCallback, useEffect, useState } from "react";
import { JamCanvasDrawerStatus } from "../types.js";
import { CanvasDrawer } from "../utils/drawer.js";

export function useMapDrawer(
  onDraw?: (status?: JamCanvasDrawerStatus) => void
) {
  const [canvasDrawer] = useState(new CanvasDrawer());
  const [isReady, setReady] = useState(false);

  const drawHandler = useCallback(
    (args?: JamCanvasDrawerStatus) => {
      args && setReady(true);
      onDraw && onDraw(args);
    },
    [onDraw]
  );

  useEffect(() => {
    const listener = canvasDrawer.observable.subscribe(({ status }) => {
      drawHandler(status);
    });

    return () => {
      listener();
    };
  }, [canvasDrawer, drawHandler]);

  return {
    canvasDrawer,
    isReady,
  };
}
